<template>
  <div class="ticker-tag-search-container position-relative">
  <!-- Tag Search autocomplete input container  -->
    <b-container class="container-fluid mx-0 px-0 rounded-sm">
      <b-row class="m-0 p-0">
        <b-col class="p-0">

          <b-form-input
            id="tag-autocomplete"
            type="search"
            v-model="searchTickerTag"
            placeholder="Search Tags"
            style="position: relative; z-index: 999"
            class="tag-autocomplete"
          >
          </b-form-input>

        </b-col>
      </b-row>
    </b-container>

    <!--
      Tag Search Results container.
      Tag Search allows for multiple tags to be searched and selected across different sources,
      e.g.: select the day high price from historical data, and select the total earnings from
      standardized financials.

      To enable this, all selected tags are stored in a "selectedTags" constant,
      and the selected tags block above is used to interact with all the tags selected
      in the current session.

      Once the tag selection is complete, hit "Go" to build a chart on the selected tags.
    -->
    <div class="ticker-tag-search-results-wrapper position-absolute mx-0 pr-0 pb-2 w-100 bg-light">
      <b-container class="ticker-tag-search-results-container mx-0 px-0"
                   v-for="(tags, tagSrc) in tagSearchResults" :key="tagSrc"
      >
        <b-row class="always-show-on-top p-0 m-0">
          <b-col class="text-left ticker-tag-search-result-header bg-info
                 border-bottom border-top border-info pl-3 py-1 m-0">
            {{tagSrc}}
          </b-col>
        </b-row>
        <b-row v-for="tag in tags" :key="tag.id" class="always-show-on-top p-0 m-0">
          <b-col class="text-left ticker-tag-search-result border border-white bg-light
                          pl-3 py-1 m-0"
                 v-on:click="selectTag(tag)"
          >
            {{tag.name}}
          </b-col>
        </b-row>
      </b-container>
    </div>
  </div>
</template>

<script>
import { TICKER_TAG_URL } from '@/assets/js/endpoints';
import apiCall from '../assets/js/stockifyApi';

export default {
  name: 'TagAutocomplete',
  props: {
  },
  data() {
    return {
      searchTickerTag: '',
      tagSearchResults: {},
      selectedTags: null,
    };
  },
  methods: {
    searchTags(val) {
      const tickerTagSearchUrl = `${TICKER_TAG_URL}?str=${val}`;

      apiCall({ method: 'GET', url: tickerTagSearchUrl }).then((resp) => {
        const dataTags = resp.data;
        const tagSearchResultsLocal = {};
        dataTags.forEach((datatag) => {
          // noinspection JSUnresolvedVariable
          const statementCode = datatag.statement_code;
          if (!(statementCode in tagSearchResultsLocal)) {
            tagSearchResultsLocal[statementCode] = [];
          }
          tagSearchResultsLocal[statementCode].push(datatag);
        });
        // this.tagSearchResults = dataTags;
        this.tagSearchResults = tagSearchResultsLocal;
      });
    },
    selectTag(tag) {
      this.tagSearchResults = [];
      this.searchTickerTag = '';
      this.$emit('tagSelected', tag);
    },
  },
  watch: {
    searchTickerTag(val) {
      if (val.length >= 3) {
        this.searchTags(val);
      } else {
        this.tagSearchResults = [];
      }
    },
  },
};
</script>

<style>
  .always-show-on-top {
    position: relative;
    z-index: 1000;
  }
  /*noinspection CssUnusedSymbol*/
  .ticker-tag-search-results-container {
    z-index: 1000;
  }
  .ticker-tag-selected:hover {
    cursor: pointer;
  }
  .ticker-tag-search-result {
  }
  .ticker-tag-search-result:hover {
    cursor: pointer;
    background-color: deepskyblue !important;
  }

</style>
